import { computed, ComputedRef, ref, Ref } from 'vue';
import { defineStore } from 'pinia';
import { RoleChoice, UserType } from '@/common/interfaces';

export declare type UserIdentifier = string;

export const useAccountStore = defineStore('account', () => {
	const user: Ref<UserType | null> = ref(null);

	const name: ComputedRef<string> = computed(
		() => {
			if (user.value === null) return '';

			return `${user.value.firstName} ${user.value.lastName}`;
		}
	);

	const setAccount = (account: UserType): void => {
		user.value = account;
	}

	return {
		user, name,
		setAccount
	};
});
